
namespace RioERP.Carts {

    @Serenity.Decorators.registerClass()
    export class FranchiseeProductCategoryDialog extends Serenity.EntityDialog<FranchiseeProductCategoryRow, any> {
        protected getFormKey() { return FranchiseeProductCategoryForm.formKey; }
        protected getIdProperty() { return FranchiseeProductCategoryRow.idProperty; }
        protected getLocalTextPrefix() { return FranchiseeProductCategoryRow.localTextPrefix; }
        protected getService() { return FranchiseeProductCategoryService.baseUrl; }
        protected getDeletePermission() { return FranchiseeProductCategoryRow.deletePermission; }
        protected getInsertPermission() { return FranchiseeProductCategoryRow.insertPermission; }
        protected getUpdatePermission() { return FranchiseeProductCategoryRow.updatePermission; }

        protected form = new FranchiseeProductCategoryForm(this.idPrefix);

    }
}